import React from 'react';
import PropTypes from 'prop-types';

import ClipLoader from 'react-spinners/ClipLoader';

const override = {display: 'block', margin: '0 auto', borderColor: 'red'};

const ReactSpinner = (props) => {
    const {loadings} = props;

    return (
        <ClipLoader
            color="#ffffff"
            loading={loadings}
            cssOverride={override}
            size={150}
        />
    );
};

ReactSpinner.propTypes = {
    loadings: PropTypes.bool
};

ReactSpinner.defaultProps = {
    loadings: false
};

export default ReactSpinner;
